//Hide main nav on page load
const navItems = $('.nav-items');
navItems.hide();


//Display and hide main nav menu. Animate spoolwheel icon
const rotateIcon = $('.rotate');
const nav = $('nav');
const navList = $('nav li');
const link = $('nav a, .footer-links-primary a');

let hideNav = () => {
	nav.fadeOut(600);
	navItems.delay(800).slideUp();
}

let revealSetlist = (delay) => {
	setlist.delay(delay).slideDown();
	revealSwitch = true;
}


//Hide and show nav items when user interacts with menu icon (spoolwheel)
rotateIcon.on('click', function(e) {
	e.preventDefault();
	$(this).toggleClass('down');

	if ($(this).hasClass('down')) {
		//.show() is required in order to 'reset' .fadeOut() if user has already hidden nav – see after else
		nav.show();
		
		navList.hide();
		navItems.slideDown();
		
		//Fade in each nav item one after the other
		navList.each(function(index) {
		    $(this).delay(600 * (index + 1)).fadeIn(300);
		});
	} else {
		hideNav();
			
	}
});

//Hide nav when user interacts with nav items (and subsequent scroll to relevant section of page)
link.on('click', function(e) {
	e.preventDefault();

	//Play video – video plays fullpage
	//Find out about events – scroll to events
	//Learn about the band – scroll to band carousel
	//Make an enquiry – scroll to enquiry

	let anchor = $(this).attr('class');
	let elementToScrollTo;
	let delay;

	switch(anchor) {
		case 'play-video':
	    	//Play video
	    	break;
		case 'read-setlist':
			elementToScrollTo = $('#hero-buttons');
			break;
		case 'find-events':
			elementToScrollTo = $('#events');
			break;
		case 'learn-band':
		    elementToScrollTo = $('#band-info');
		    break;
		case 'make-contact':
			elementToScrollTo = $('#enquiry-form');
			break;
	  	default:
	    	elementToScrollTo = $('html');
	}

	rotateIcon.toggleClass('down');
	hideNav();
	
	if ($(this).parent().parent().attr('class') === 'footer-links-primary') {
		delay = 0;
	} else {
		delay = 1000;
	}

	$('html, body').delay(delay).animate({scrollTop: elementToScrollTo.offset().top}, 1500);

	if (anchor === 'read-setlist') {
		revealSetlist(2600);
	}
});

//Watch video; reveal and hide overlay
const overlay = $('.overlay');
const videoButton = $('button.video, li>a.play-video');
let isDisplayed;

videoButton.on('click', (e) => {
	e.preventDefault();
	overlay.css(
		{
			'z-index': 100,
			'display': 'block'
		}
	);
	isDisplayed = true;
});

overlay.on('click', () => {
	if (isDisplayed === true) {
		overlay.css(
			{
				'z-index': -100,
				'display': 'none'
			}
		);
		isDisplayed = false;
	}
});


//Show correct options for the chosen event type
const select = $('#event-select');
const weddingOpts = $('.wedding-opt');
let opt;

select.on('change', function() {
	opt = $(this).val();
	console.log(opt);

	if (opt === 'Wedding event') {
		weddingOpts.removeAttr('disabled');
		weddingOpts.parent().slideDown();
	} else {
		weddingOpts.attr('disabled', 'disabled').removeAttr('checked');
		weddingOpts.parent().slideUp();
	}
});



//Smooth scroll to booking form if 'Book Us' button is clicked
const scrollButton = $('button.scroll');
const enquiryForm = $('#enquiry-form');

scrollButton.on('click', () => {
	$('html, body').animate({scrollTop: enquiryForm.offset().top}, 1500);
});



//Display and hide setlist
const revealButton = $('.reveal');
const setlist = $('#setlist');
const events = $('#hero-buttons');
let revealSwitch = false;

setlist.hide();

revealButton.on('click', () => {
	if (revealSwitch === false) {
		$('html, body').animate({scrollTop: events.offset().top - 2}, 800);
		revealSetlist(800);
	} else {
		setlist.slideUp();
		revealSwitch = false;
	}
});

const closeSetlist = $('.exit');

closeSetlist.on('click', () => {
	setlist.slideUp();
	revealSwitch = false;
});

//Pressing setlist arrows moves setlist in chosen direction. Arrows either display or hide dependent on where user has scrolled to within setlist.
const scroll = $('#setlist .wrapper');
const arrow = $('.nav-arrow');
const leftArrow = $('.nav-arrow.left');
const rightArrow = $('.nav-arrow.right');
let lastLeftLocation = 0;

scroll.on('scroll', function(e) {
	console.log(lastLeftLocation);

	if (lastLeftLocation < 201) {
		leftArrow.hide();
		rightArrow.show();
	} else if (lastLeftLocation > 5250) {
		rightArrow.hide();
		leftArrow.show();
	} else if (lastLeftLocation >= 201 || lastLeftLocation >= 5250) {
		leftArrow.show();
		rightArrow.show();
	}

	lastLeftLocation = e.currentTarget.scrollLeft;
});

arrow.on('click', function() {
	if ($(this).is('.nav-arrow.left')) {
		scroll.animate({scrollLeft: '-=600'}, 300);
		return false;
	} else if ($(this).is('.nav-arrow.right')) {
		scroll.animate({scrollLeft: '+=600'}, 300);
		return false;
	}
});

//Form controls
const form = $('form');
const formOverlay = $('.overlay-wrapper');
const message = $('.overlay-text');
let elementToScrollTo, delay;

let changeFormState = (displaySetting, disabledIsSet) => {
	formOverlay.css('display', displaySetting);
	$('form *').prop('disabled', disabledIsSet);
}

let retrieveMessage = function(successState) {
	let messageData = [];

	let addMessage = (messageType) => {
		message.find('h1').html(messageData[messageType].title);
		message.find('h2').html(messageData[messageType].byline);
		message.find('p').html(messageData[messageType].text);
	}

	$.getJSON('../assets/data/form.json', function(data) {
		$.each(data, function(key, value) {
			messageData.push(value);
		})

		if (successState === true) {
			addMessage(0);
		} else  if (successState === false) {
			addMessage(1);
		} else {
			addMessage(2);
		}
	});
}

$('button.exit').on('click', function(e) {
	e.preventDefault();

	let formState = changeFormState('none', false);
});

form.on('submit', function(e) {

	e.preventDefault();

	let successMessage;

	//Ensure email and confirm email match
	let match = $('#email').val() == $('#email-confirm').val();
	
	$.ajax({
		method: 'POST',
		url: 	'https://script.google.com/macros/s/AKfycbxzOM2Kam4maqYBbTxpOGUVSwhZbnpPlbPvnk9MKbw4odiEjLEK/exec'
	})

	.done(function() {
		//Success text in overlay
		successMessage = retrieveMessage(true);
		form.trigger('reset');
	})
	
	.fail(function() {
		//Fail text in overlay
		successMessage = retrieveMessage(false);
	})
	
	.always(function() {
		//Disable form
		let formState = changeFormState('flex', true);
	});
});

//Datepicker
$( "#datepicker" ).datepicker({
	numberOfMonths: 2,
	showButtonPanel: true
});

//Homepage image carousel
$(document).ready(function(){
	$('.autoplay-carousel').slick({
		infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 3,
        slidesToScroll: 2,
        pauseOnHover: false,
        responsive: [{
			breakpoint: 750,
			settings: {
				slidesToShow: 2,
			}
		}, {
			breakpoint: 600,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}]
	});
});